import React, { createContext, useState } from 'react';

export const IntroPlaybackContext = createContext({ active: false, setActive: () => {} });

export default function IntroPlayback({ children }) {
  const [active, setActive] = useState(false);
  return <IntroPlaybackContext.Provider value={{ active, setActive }}>{children}</IntroPlaybackContext.Provider>;
}
